'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Record = exports.ProxiedRecord = undefined;

var _immutable = require('immutable');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shouldProxy = window.newrelic && window.Proxy;
var silenceAlerts = false;
var hasPingedNewRelic = false;

var ProxiedRecord = exports.ProxiedRecord = function ProxiedRecord() {
  var recordFactory = _immutable.Record.apply(undefined, arguments);
  return new Proxy(recordFactory, {
    apply: function apply(targetFactory, factoryThis, factoryArgs) {
      var record = targetFactory.apply(factoryThis, factoryArgs);
      return new Proxy(record, {
        get: function get(targetRecord, key) {
          var property = targetRecord[key];

          if (typeof property === 'function' && key !== 'valueOf' && key !== 'toString' && key !== 'constructor' && key !== 'preventDefault' && key !== 'stopPropagation' && !silenceAlerts) {
            if (!hasPingedNewRelic) {
              hasPingedNewRelic = true;
              window.newrelic.addPageAction('uicomponentsImmutableRecordMethodUsed', {
                methodName: key
              });
            }
            _devLogger2.default.warn({
              message: 'Immutable method "' + key + '" used on event object from UIComponents',
              key: 'immutable-method-' + key,
              url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/5356'
            });

            // Silence during method call to prevent internal methods from being reported
            return new Proxy(property, {
              apply: function apply(targetProperty, propertyThis, propertyArgs) {
                silenceAlerts = true;
                var result = targetProperty.apply(propertyThis, propertyArgs);
                silenceAlerts = false;
                return result;
              }
            });
          }
          return property;
        }
      });
    }
  });
};

var exportedRecord = shouldProxy ? ProxiedRecord : _immutable.Record;

exports.Record = exportedRecord;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1755/js/utils/immutable.js
// module id = 939
// module chunks = 2 3